export enum Apis {
  AUTH2 = 'auth2',
  CLIENT = 'client',
  ADDON = 'addon'
}

export enum ApiVersion{
  V1 = 'v1'
}
